import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Config } from '@core/configuration';
export var PrivilegeTypes = {
    View: 'VIEW',
    Edit: 'EDIT',
    Create: 'CREATE',
    Allow: 'ALLOW'
};
export var PrivilegeLevels = {
    Normal: 'NORMAL',
    Internal: 'INTERNAL',
    Global: 'GLOBAL'
};
export var PrivilegesAccessOptions = {
    None: 'NONE',
    View: 'VIEW',
    Edit: 'EDIT',
    Can: 'ALLOWED',
    Cannot: 'DISABLE',
    Push: 'PUSH',
    PushAndView: 'PUSH_AND_VIEW',
    EditAll: 'EDIT_ALL',
    ViewAll: 'VIEW_ALL',
    Custom: 'CUSTOM',
    Create: 'CREATE',
    AllowAllSources: 'ALLOW_FOR_ALL_SOURCES',
    AllowAllProviders: 'ALLOW_FOR_ALL_PROVIDERS',
    AllowPush: 'ALLOW',
    DenyPush: 'DENY'
};
export var PrivilegeOwners = {
    Platform: 'PLATFORM',
    UsageAnalytics: 'USAGE_ANALYTICS',
    SearchApi: 'SEARCH_API',
    MachineLearning: 'COVEO_ML',
    Commerce: 'COMMERCE',
    Service: 'CUSTOMER_SERVICE',
    Knowledge: 'KNOWLEDGE'
};
export var SOPrivilegeDomains = {
    Administrate: 'ADMINISTRATE',
    AuthenticationEditor: 'AUTHENTICATION_EDITOR',
    ExecuteQuery: 'EXECUTE_QUERY',
    Impersonate: 'IMPERSONATE',
    QueryPipeline: 'QUERY_PIPELINE',
    QueryPipelinePreview: 'QUERY_PIPELINE_PREVIEW',
    QueryPipelineScriptEditor: 'QUERY_PIPELINE_SCRIPT_EDITOR',
    SalesforceAuthentication: 'SALESFORCE_AUTHENTICATION',
    SearchPages: 'SEARCH_PAGES',
    ViewAllContent: 'VIEW_ALL_CONTENT',
    ReplayAnyQuery: 'REPLAY_ANY_QUERY'
};
export var MLPrivilegeDomains = {
    MachineLearningModels: 'MODELS',
    AllowContentPreview: 'ALLOW_CONTENT_PREVIEW',
    AgentConfiguration: 'AGENT_CONFIGURATION'
};
export var UAPrivilegeDomains = {
    Administrate: 'ADMINISTRATE',
    Impersonate: 'IMPERSONATE',
    Exports: 'EXPORTS',
    AnalyticsData: 'ANALYTICS_DATA',
    Reports: 'REPORTS',
    CustomDimensions: 'CUSTOM_DIMENSIONS',
    NamedFilters: 'NAMED_FILTERS',
    PermissionFilters: 'PERMISSION_FILTERS',
    ViewAllReports: 'VIEW_ALL_REPORTS',
    MetricAlerts: 'METRIC_ALERTS',
    DeleteUserData: 'DELETE_USER_ANALYTICS_DATA',
    SnowflakeReaderAccounts: 'SNOWFLAKE_READER_ACCOUNTS'
};
export var ABPrivilegeDomains = {
    Activities: 'ACTIVITIES',
    Snapshots: 'SNAPSHOTS'
};
export var CommercePrivilegeDomains = {
    Catalog: 'CATALOG',
    ProductListing: 'PRODUCT_LISTING',
    MerchandisingHub: 'MERCHANDISING_HUB',
    CommerceDataHealth: 'COMMERCE_DATA_HEALTH'
};
export var ServicePrivilegeDomains = {
    CaseAssist: 'CASE_ASSIST_CONFIGURATION',
    InsightPanel: 'INSIGHT_PANEL_CONFIGURATION',
    InsightPanelInterface: 'INSIGHT_PANEL_INTERFACE',
    UseCaseAssist: 'USE_CASE_ASSIST'
};
export var KnowledgePrivilegeDomains = {
    KnowledgeHub: 'KNOWLEDGE_HUB',
    AnswerManager: 'ANSWER_MANAGER',
    ChunkInspector: 'CHUNK_INSPECTOR',
    GenAIAnalytics: 'GENAI_ANALYTICS',
    GenAIAnalyticsIndexContent: 'GENAI_ANALYTICS_INDEX_CONTENT'
};
export var PrivilegeDomains = _object_spread_props(_object_spread({}, UAPrivilegeDomains, SOPrivilegeDomains, ABPrivilegeDomains, MLPrivilegeDomains, CommercePrivilegeDomains, ServicePrivilegeDomains, KnowledgePrivilegeDomains), {
    ApiKey: 'API_KEY',
    CustomerKeys: 'CUSTOMER_KEYS',
    Source: 'SOURCE',
    Field: 'FIELD',
    ExploreDictionaryFields: 'EXPLORE_DICTIONARY_FIELDS',
    SecurityCache: 'SECURITY_CACHE',
    SecurityProvider: 'SECURITY_PROVIDER',
    Group: 'GROUP',
    GlobalGroup: 'GLOBAL_GROUP',
    Organization: 'ORGANIZATION',
    OrganizationAdministration: 'ORGANIZATION_ADMINISTRATION',
    OnPremiseAdministration: 'ON_PREMISE_ADMINISTRATION',
    InternalUser: 'INTERNAL_USER',
    Ops: 'OPS',
    Index: 'INDEX',
    ElasticIndex: 'ELASTIC_INDEX',
    Infrastructure: 'INFRASTRUCTURE',
    MCPServerConfigurations: 'MCP_SERVER_CONFIGURATION',
    ManageLicense: 'MANAGE_LICENSE',
    ManagePlatformFeatureModifiers: 'MANAGE_PLATFORM_FEATURE_MODIFIERS',
    ManageCustomerLicense: 'MANAGE_CUSTOMER_LICENSE',
    ManageCustomerLicenseOverrides: 'MANAGE_CUSTOMER_LICENSE_OVERRIDES',
    Extensions: 'INDEXING_PIPELINE_EXTENSION',
    SAMLIdentityProvider: 'SAML_IDENTITY_PROVIDER',
    OrganizationTemplate: 'ORGANIZATION_TEMPLATE',
    Subscription: 'SUBSCRIPTION',
    OrganizationsExport: 'ORGANIZATIONS_EXPORT',
    SearchHubs: 'SEARCH_USAGE_METRICS',
    QueryLogs: 'QUERY_LOGS',
    LogicalIndex: 'LOGICAL_INDEX',
    TemporaryAccess: 'TEMPORARY_ACCESS',
    TemporaryAccessRequest: 'TEMPORARY_ACCESS_REQUEST',
    CrawlingModules: 'CRAWLING_MODULE',
    ResourceSnapshots: 'SNAPSHOTS',
    Link: 'LINK',
    SourceMetadata: 'SOURCE_METADATA',
    ConnectivityDiagnosticLogs: 'CONNECTIVITY_DIAGNOSTIC_LOGS',
    CrawlingModuleLogRequest: 'CRAWLING_MODULE_LOG_REQUEST',
    Project: 'PROJECTS',
    TrackingId: 'TRACKING_ID',
    PushDocument: 'PUSH_DOCUMENT',
    PushIdentity: 'PUSH_IDENTITY'
});
export var PrivilegesLists = /*#__PURE__*/ function(PrivilegesLists) {
    PrivilegesLists[PrivilegesLists["Groups"] = 0] = "Groups";
    PrivilegesLists[PrivilegesLists["ApiKeys"] = 1] = "ApiKeys";
    PrivilegesLists[PrivilegesLists["GlobalGroups"] = 2] = "GlobalGroups";
    PrivilegesLists[PrivilegesLists["User"] = 3] = "User";
    PrivilegesLists[PrivilegesLists["Other"] = 4] = "Other";
    return PrivilegesLists;
}({});
var organizationUrl = "".concat(Config.CloudPlatform.url, "/rest/organizations/{organizationName}");
var _obj;
export var privilegesListsIds = (_obj = {}, _define_property(_obj, 0, 'organization-privileges'), _define_property(_obj, 2, 'global-groups-privileges'), _define_property(_obj, 1, 'apikeys-privileges'), _define_property(_obj, 3, 'user-privileges'), _obj);
var _obj1;
export var privilegesListsUrls = (_obj1 = {}, _define_property(_obj1, 0, "".concat(organizationUrl, "/privileges")), _define_property(_obj1, 2, "".concat(Config.CloudPlatform.url, "/rest/globalprivileges")), _define_property(_obj1, 1, "".concat(organizationUrl, "/privileges/apikeys")), _define_property(_obj1, 3, "".concat(organizationUrl, "/members/privileges")), _obj1);
var allTargetIds = '*';
var granularDomains = {
    Sources: "".concat(PrivilegeDomains.Source, "_").concat(PrivilegeOwners.Platform, "_").concat(PrivilegeLevels.Normal),
    Groups: "".concat(PrivilegeDomains.Group, "_").concat(PrivilegeOwners.Platform, "_").concat(PrivilegeLevels.Normal),
    ApiKeys: "".concat(PrivilegeDomains.ApiKey, "_").concat(PrivilegeOwners.Platform, "_").concat(PrivilegeLevels.Normal),
    Extensions: "".concat(PrivilegeDomains.Extensions, "_").concat(PrivilegeOwners.Platform, "_").concat(PrivilegeLevels.Normal),
    PushDocuments: "".concat(PrivilegeDomains.PushDocument, "_").concat(PrivilegeOwners.Platform, "_").concat(PrivilegeLevels.Normal),
    PushIdentities: "".concat(PrivilegeDomains.PushIdentity, "_").concat(PrivilegeOwners.Platform, "_").concat(PrivilegeLevels.Normal),
    Pipelines: "".concat(PrivilegeDomains.QueryPipeline, "_").concat(PrivilegeOwners.SearchApi, "_").concat(PrivilegeLevels.Normal),
    MerchandisingHubs: "".concat(PrivilegeDomains.MerchandisingHub, "_").concat(PrivilegeOwners.Commerce, "_").concat(PrivilegeLevels.Normal)
};
var potentPrivileges = [
    {
        owner: PrivilegeOwners.SearchApi,
        targetDomain: PrivilegeDomains.ExecuteQuery,
        targetId: allTargetIds
    },
    {
        owner: PrivilegeOwners.SearchApi,
        targetDomain: PrivilegeDomains.Impersonate,
        targetId: allTargetIds
    },
    {
        owner: PrivilegeOwners.SearchApi,
        targetDomain: PrivilegeDomains.ViewAllContent,
        targetId: allTargetIds
    },
    {
        owner: PrivilegeOwners.UsageAnalytics,
        targetDomain: PrivilegeDomains.Administrate,
        targetId: allTargetIds
    },
    {
        owner: PrivilegeOwners.UsageAnalytics,
        targetDomain: PrivilegeDomains.ViewAllReports,
        targetId: allTargetIds
    },
    {
        owner: PrivilegeOwners.UsageAnalytics,
        targetDomain: PrivilegeDomains.DeleteUserData,
        targetId: allTargetIds
    },
    {
        owner: PrivilegeOwners.Platform,
        targetDomain: PrivilegeDomains.OnPremiseAdministration,
        targetId: allTargetIds,
        type: PrivilegeTypes.View
    },
    {
        owner: PrivilegeOwners.Platform,
        targetDomain: PrivilegeDomains.OnPremiseAdministration,
        targetId: allTargetIds,
        type: PrivilegeTypes.Edit
    },
    {
        owner: PrivilegeOwners.Platform,
        targetDomain: PrivilegeDomains.Group,
        targetId: allTargetIds,
        type: PrivilegeTypes.Edit
    },
    {
        owner: PrivilegeOwners.Platform,
        targetDomain: PrivilegeDomains.SourceMetadata,
        targetId: allTargetIds,
        type: PrivilegeTypes.View
    },
    {
        owner: PrivilegeOwners.Platform,
        targetDomain: PrivilegeDomains.CrawlingModuleLogRequest,
        targetId: allTargetIds,
        type: PrivilegeTypes.Create
    },
    {
        owner: PrivilegeOwners.Platform,
        targetDomain: PrivilegeDomains.CrawlingModuleLogRequest,
        targetId: allTargetIds,
        type: PrivilegeTypes.View
    }
];
/**
 * Privileges that causes "Restrictive" options in the privileges table.
 * this behavior prevents the user from creating a faulty combination.
 */ var restrictivePrivileges = [
    {
        owner: PrivilegeOwners.SearchApi,
        targetDomain: PrivilegeDomains.ExecuteQuery,
        targetId: allTargetIds
    },
    {
        owner: PrivilegeOwners.SearchApi,
        targetDomain: PrivilegeDomains.Impersonate,
        targetId: allTargetIds
    }
];
export var PrivilegesConstants = {
    allTargetIds: allTargetIds,
    granularDomains: granularDomains,
    potentPrivileges: potentPrivileges,
    restrictivePrivileges: restrictivePrivileges
};

//# sourceMappingURL=PrivilegesConstants.js.map